import axios from "@/axios";

const getDefaultState = () => {
  return {
    bulkBatches: [],
    isLoading: false,
  };
};

const moduleCategoryCardsBulk = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getBulkBatches(state) {
      return state.bulkBatches;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
  },
  mutations: {
    setBulkBatches(state, batches) {
      state.bulkBatches = batches;
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    clearModule(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async uploadBulk({ commit }, formData) {
      commit("setIsLoading", true);
      try {
        const response = await axios.post("tools/category_cards/bulk", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response;
      } finally {
        commit("setIsLoading", false);
      }
    },

    async fetchBulkBatches({ commit }, { workspace_id }) {
      commit("setIsLoading", true);
      try {
        const response = await axios.get("tools/category_cards/bulk", {
          params: { workspace_id },
        });
        if (response && response.data && response.data.data) {
          commit("setBulkBatches", response.data.data);
        }
        return response;
      } finally {
        commit("setIsLoading", false);
      }
    },

    async deleteBulkBatch({ commit }, batchId) {
      commit("setIsLoading", true);
      try {
        const response = await axios.delete(`tools/category_cards/bulk/${batchId}`);
        return response;
      } finally {
        commit("setIsLoading", false);
      }
    },
  },
};

export default moduleCategoryCardsBulk;
